import { EditableSignature, type EditableSignatureProps } from './EditableSignature';
import { StoredSignature, type StoredSignatureProps } from './StoredSignature';

type EditableVSignatureProps = EditableSignatureProps & {
  readOnly?: false;
  signature?: never;
};

type ReadOnlyVSignatureProps = StoredSignatureProps & {
  readOnly: true;
  onChange?: never;
  prefixHelperText?: never;
  invalid?: never;
  typedNameLabel?: never;
};

type VSignatureProps = EditableVSignatureProps | ReadOnlyVSignatureProps;

const isReadOnly = (props: VSignatureProps): props is ReadOnlyVSignatureProps =>
  props.readOnly === true;

const VSignature = (props: VSignatureProps) => {
  if (isReadOnly(props)) {
    return <StoredSignature signature={props.signature} />;
  }

  return (
    <EditableSignature
      prefixHelperText={props.prefixHelperText}
      invalid={props.invalid}
      typedNameLabel={props.typedNameLabel}
      onChange={props.onChange}
    />
  );
};

export default VSignature;
